var Response = /*#__PURE__*/function () {
  function Response(error, queryValues, response, values) {
    this.error = void 0;
    this.queryValues = void 0;
    this.response = void 0;
    this.values = void 0;
    this.error = error;
    this.queryValues = queryValues;
    this.response = response;
    this.values = values;
  }

  var _proto = Response.prototype;

  _proto.isEmpty = function isEmpty() {
    return this.error === null && this.response === undefined && this.values === undefined && this.queryValues === undefined;
  };

  _proto.isError = function isError() {
    return this.error !== null;
  };

  _proto.getError = function getError() {
    return this.error;
  };

  _proto.getQueryValues = function getQueryValues() {
    return this.queryValues;
  };

  _proto.getResponse = function getResponse() {
    return this.response;
  };

  _proto.getValues = function getValues() {
    return this.values;
  };

  _proto.getResults = function getResults() {
    var _this$response;

    return (_this$response = this.response) == null ? void 0 : _this$response.get('results');
  };

  _proto.getRedirects = function getRedirects() {
    var _this$response2;

    return (_this$response2 = this.response) == null ? void 0 : _this$response2.get('redirects');
  };

  _proto.getActivePromotions = function getActivePromotions() {
    var _this$response3;

    return (_this$response3 = this.response) == null ? void 0 : _this$response3.get('activePromotions');
  };

  _proto.getTotalResults = function getTotalResults() {
    var _this$response4;

    return (_this$response4 = this.response) == null ? void 0 : _this$response4.get('totalResults');
  };

  _proto.getTime = function getTime() {
    var _this$response5;

    return (_this$response5 = this.response) == null ? void 0 : _this$response5.get('time');
  };

  _proto.getQueryId = function getQueryId() {
    var _this$response6;

    return (_this$response6 = this.response) == null ? void 0 : _this$response6.get('queryId');
  };

  _proto.getAggregates = function getAggregates() {
    var _this$response7;

    return (_this$response7 = this.response) == null ? void 0 : _this$response7.get('aggregates');
  };

  _proto.getAggregateFilters = function getAggregateFilters() {
    var _this$response8;

    return (_this$response8 = this.response) == null ? void 0 : _this$response8.get('aggregateFilters');
  };

  _proto.getFeatureScoreWeight = function getFeatureScoreWeight() {
    var _this$response9;

    return (_this$response9 = this.response) == null ? void 0 : _this$response9.get('featureScoreWeight');
  };

  _proto.getBanners = function getBanners() {
    var _this$response10;

    return (_this$response10 = this.response) == null ? void 0 : _this$response10.get('banners');
  };

  return Response;
}();

export { Response };
//# sourceMappingURL=Response.esm.js.map
